/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Subtract_Frame_From_EndInputs */



/**
* | output |
* | --- |
* | "Decrease end time by one frame" |
*
* @param {Shortcut_Keys_Desc_Subtract_Frame_From_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_subtract_frame_from_end = /** @type {((inputs?: Shortcut_Keys_Desc_Subtract_Frame_From_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Subtract_Frame_From_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diminuer le temps de fin d'une image")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verringere die Endzeit um ein Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riduci l'ora di fine di un fotogramma")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уменьшите время окончания на один кадр.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disminuir el tiempo de finalización en un cuadro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将结束时间减少一帧")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時間を1フレーム減らす")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति समय को एक फ्रेम से कम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminua o tempo final em um quadro.")
	return /** @type {LocalizedString} */ ("Decrease end time by one frame")
});